import { KeyValueCardConfig, CardData, KeyValuePair } from '../types'

interface KeyValueProps {
  config: KeyValueCardConfig
  data: CardData
}

export function KeyValue({ config, data }: KeyValueProps) {
  const { columns } = config
  const primary = (data.primary as KeyValuePair[]) || []
  const secondary = data.secondary

  return (
    <div className="flex h-full w-full items-center justify-center">
      <div className="flex flex-col gap-6">
        <div
          style={{ gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))` }}
          className="m-auto grid gap-0.5 rounded-md bg-border p-0.5"
        >
          {primary.map(({ label, value }) => (
            <div key={label} className="flex flex-col">
              <div className="bg-background p-3 text-sm text-muted-foreground">{label}</div>
              <div className="bg-background px-3 pb-3 text-center text-2xl font-bold">{value}</div>
            </div>
          ))}
        </div>
        {secondary && <div className="text-sm text-muted-foreground">{secondary}</div>}
      </div>
    </div>
  )
}
